import React from 'react';
import { Grid } from '@material-ui/core';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { signOff } from 'src/login/business-logic/sign-off';
import { trainingModeOff } from 'src/login/business-logic/training-mode-off';
import { BaseButton } from 'src/common/components/base-button';
import { useTranslation } from 'react-i18next';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

export interface TrainingLogoutButtonsProps {
  trainingModeActive: boolean;
}

export const TRAINING_MODE_LOGOUT_MODAL = 'training-mode-logout-modal';

const TrainingLogoutButtons = ({ trainingModeActive }: TrainingLogoutButtonsProps): JSX.Element => {
  const trainingModeClasses = trainingModeStyles();
  const { t } = useTranslation();
  const configuration = getCurrentXLRConfig();

  return (
    <Grid container className={trainingModeClasses.dialogContent}>
      <Grid item className={trainingModeClasses.dialogItemContent}>
        <BaseButton
          className={trainingModeClasses.closeButton}
          data-testid='Close'
          buttonType='white'
          color='default'
          onClick={() => {
            popEmeraldModal(TRAINING_MODE_LOGOUT_MODAL);
          }}
        >
          {t('Cancel')}
        </BaseButton>
        <BaseButton
          className={trainingModeClasses.acceptButton}
          data-testid='Regular-mode-logout'
          onClick={() => {
            trainingModeOff(configuration.serverSideExitTrainingMode);
          }}
        >
          {t('ExitTrainingMode')}
        </BaseButton>
        <BaseButton
          className={trainingModeClasses.acceptButton}
          data-testid='Logout'
          onClick={() => {
            signOff(trainingModeActive);
          }}
        >
          {t('SignOffCommand')}
        </BaseButton>
      </Grid>
    </Grid>
  );
};

export default TrainingLogoutButtons;
